
import {observable} from "mobx";
import {StoreBase, StoreDataType} from "shared/utilities/Store/StoreBase";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";
import {PRControlTypes} from "../PRControlFactory";






export class ImageControlOptions extends PDFControlBaseOptions{
    @observable
    Type:string;
    URL:string;
    URLId:string;
    TemplateFieldName:string;

    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Type=PRControlTypes [PRControlTypes.Image];
        this.URL='';
        this.URLId='';
        this.TemplateFieldName='';
    }
}


